import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getDescribeImage = (params) => {
	var url = ApiRouters.DESCRIBEIMAGE;
	return api.get(url, { params });
};

export const getDescribeImageDetail = (id, params) => {
	var url = `${ApiRouters.DESCRIBEIMAGE}/${id}`;
	return api.get(url, { params });
};

export const createQuesDescribeImage = (body) => {
	var url = ApiRouters.DESCRIBEIMAGE;
	return api.post(url, body);
};

export const updateDescribeImageDetail = (body) => {
	var url = `${ApiRouters.DESCRIBEIMAGE}/${body.id}`;
	return api.put(url, body);
};

export const deleteDescribeImage = (id) => {
	var url = `${ApiRouters.DESCRIBEIMAGE}/${id}`;
	return api.delete(url);
};
